<div class="container">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div>
    <div class="mb_16">{{ message }}</div>
  </div>
  @if (showOption === true) {
    <div>
      <p>{{'DeleteConfirm' | translate }}</p>
      @if (showSCP) {
        <div>
          <mat-checkbox type="checkbox" id="scp" name="scp" value="scp"
            (change)="selectionChange($event.checked, 'scp')">
            <span class="inner_label">{{ SynappxCloudPrintLabel }}</span>
          </mat-checkbox>
        </div>
      }
      @if (showSynappxGo) {
        <div>
          <mat-checkbox [disabled]="isSynappx" id="synappx" name="synappx" value="synappx" [checked]="isSynappx"
            (change)="selectionChange($event.checked, 'synappx')">
            <span class="inner_label">{{ synappxGoLabel }}</span>
          </mat-checkbox>
        </div>
      }
      @if (showSynappxManage) {
        <div>
          <mat-checkbox [disabled]="isRmmAdmin" type="checkbox" id="rmm" name="rmm" value="rmm" [checked]="isRmmAdmin"
            (change)="selectionChange($event.checked, 'rmm')">
            <span class="inner_label">{{ synappxManageLabel }}</span>
          </mat-checkbox>
        </div>
      }
    </div>
  }
  <div mat-dialog-actions>
    <button mat-button type="submit" (click)="onOk()" id="id-ok" class="primary_btn">{{"Ok" |translate}}</button>
    @if (!alertMode) {
      <button mat-button (click)="onCancel()" id="id-cancel" class="secondary_btn">{{"Cancel"
      |translate}}</button>
    }
  </div>
</div>